import React from 'react'

import { Col, Form } from '_zari/core'

import { MonedasConstant } from 'constants/index'

const SimboloMonedaFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='&ensp;' md={12} />
      <Col md={12}>
        <Form.InputText
          id='input-simboloMoneda'
          name='input-simboloMoneda'
          value={MonedasConstant.__dictionary[iValue].signo}
          disabled
        />
      </Col>
    </Form.Group>
  )
}

export default React.memo(SimboloMonedaFormGroup)
